import { getButtonType, returnType } from '../../OrderHistory/components/buttons/manageButtonType'
import useGetItemToReturn from './useGetItemToReturn'
import useGetLifetimeReplacementFlag from './useGetLifetimeReplacementFlag'

const useManageReturnType = ({
  orderDetails,
  partSku,
}) => {
  const isLifetimeReplacement = useGetLifetimeReplacementFlag()

  const part = useGetItemToReturn({
    orderDetails,
    partSku,
  })

  let isLRPart = false
  const isEligible = Boolean(part)
  if (part?.sku && partSku === part?.sku && part?.isLifetimeReplacement === '1') {
    isLRPart = true
  }

  let type = getButtonType()
  if (!isLifetimeReplacement || !partSku || !isLRPart ||
    (isLifetimeReplacement && partSku && !isEligible)) {
    type = returnType.return
  }

  return type
}

export default useManageReturnType
